import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Logo } from '@lnr-v2/ui';
import styles from './NavigationBar.module.css';
import { useCursor } from '@/contexts/CursorContext';

export const NavigationBar = ({
  isLogoVisible,
  isMenuOpen,
  onToggleMenu,
}: {
  isLogoVisible: boolean;
  isMenuOpen: boolean;
  onToggleMenu: () => void;
}) => {
  const [isInDetailCase, setIsInDetailCase] = useState(false);

  const location = useLocation();
  const navigate = useNavigate();
  const { setState } = useCursor();

  const onMouseEnter = () => {
    setState('link');
  };

  const onMouseLeave = () => {
    setState('default');
  };

  useEffect(() => {
    setIsInDetailCase(location.pathname.includes('/cases/'));
  }, [location]);

  const goBack = () => {
    navigate(-1);
  };

  return (
    <header className={styles.navigationBar}>
      <button
        aria-label="Go Back"
        className={`${styles.goBackButton} ${!isInDetailCase || isMenuOpen ? styles.hidden : styles.visible}`}
        onClick={goBack}
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}
      >
        <span>←</span>
        <span>Back</span>
      </button>

      <a
        href="/"
        className={`${styles.logo} ${location.pathname.includes('/cases/') ? styles.logoWhite : ''} ${styles.logoWrapper} ${isLogoVisible ? styles.visible : styles.hidden}`}
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}
      >
        <Logo src="/logo.svg" width={55.5} height={42.84} />
      </a>

      <button
        aria-label={isMenuOpen ? 'Close menu' : 'Open menu'}
        className={`${styles.menuButton} ${isMenuOpen ? styles.open : ''}`}
        onClick={onToggleMenu}
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}
      >
        <span />
        <span />
      </button>
    </header>
  );
};
